<template>
  <div class="main">
    <main-section
      :is-link-button="true"
      colorBuy='#5493CC'
      color="transparent"
    />
    <div class="docs">
      <div class="docs__nav">
        <a href="#shift-schedules" class="docs__nav-link">Смены</a>
        <a href="#reviews" class="docs__nav-link">Отзывы</a>
        <a href="#newsour" class="docs__nav-link">Наши новости</a>
      </div>
    </div>
    <shift-selection />
    <reviews />
    <news-slider/>
    <maps />
  </div>
</template>

<style scoped lang="scss">
.docs {
  padding: 48px 0 0px;
  max-width: 1080px;
  margin: 0 auto;
  @media screen and (max-width: 1300px) {
    max-width: 620px;
  }
  @media screen and (max-width: 680px) {
    max-width: 300px;
  }
  &__title {
    font-family: RF Dewi Expanded;
    font-size: 64px;
    font-weight: 900;
    line-height: 77px;
    margin: 34px 0 54px;
    @media screen and (max-width: 1300px) {
      font-size: 46px;
      line-height: 55px;
    }
    @media screen and (max-width: 680px) {
      font-size: 24px;
      line-height: 29px;
    }
  }
  &__nav {
    &-link {
      font-family: Montserrat;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      display: inline-block;
      margin: 8px 12px 0 0;
      border: 2px solid;
      padding: 12px 24px;
      border-radius: 50px;
      text-decoration: none;
      transition: background-color 0.3s, color 0.3s;
      @media screen and (max-width: 1300px) {
        font-size: 14px;
        line-height: 18px;
        padding: 8px 14px;
        margin: 0 12px 18px 0;
      }
      &:nth-child(1) {
        color: #9dcefc;
        border-color: #9dcefc;
        &:hover {
          background-color: #9dcefc;
          color: white;
        }
      }
      &:nth-child(2) {
        color: #f98419;
        border-color: #f98419;
        &:hover {
          background-color: #f98419;
          color: white;
        }
      }
      &:nth-child(3) {
        color: #fb6f8a;
        border-color: #fb6f8a;
        &:hover {
          background-color: #fb6f8a;
          color: white;
        }
      }
      &:nth-child(4) {
        color: #5ec0a9;
        border-color: #5ec0a9;
        &:hover {
          background-color: #5ec0a9;
          color: white;
        }
      }
      &:nth-child(5) {
        color: #676fb2;
        border-color: #676fb2;
        &:hover {
          background-color: #676fb2;
          color: white;
        }
      }
      &:nth-child(6) {
        color: #3fd33c;
        border-color: #3fd33c;
        &:hover {
          background-color: #3fd33c;
          color: white;
        }
      }
      &:nth-child(7) {
        color: #1a66ac;
        border-color: #1a66ac;
        &:hover {
          background-color: #1a66ac;
          color: white;
        }
      }
    }
  }
  &__info {
    padding: 42px 0 0;
  }
  &__card {
    ul {
      padding-inline-start: 20px;
    }
  }
  &__text {
    font-family: Montserrat;
    font-size: 18px;
    font-weight: 400;
    line-height: 23px;
    @media screen and (max-width: 680px) {
      font-size: 14px;
      line-height: 18px;
    }
  }
  &__info-text {
    font-family: Montserrat;
    font-size: 18px;
    font-weight: 400;
    line-height: 29px;
    @media screen and (max-width: 680px) {
      font-size: 14px;
      line-height: 18px;
    }
    &-link {
      color: black;
      font-weight: bold;
    }
  }
  &__sub-info {
    display: inline-block;
    width: 100%;
    font-family: Montserrat;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    border-top: 1px solid #dfdfdf;
    padding: 16px 0 0;
    a {
      color: black;
    }
    @media screen and (max-width: 680px) {
      font-size: 14px;
      line-height: 17px;
    }
  }
}
</style>

<script>
import { mapActions } from 'vuex'
import ShiftSelection from '@/components/blocks/ShiftSelection'
import MainSection from '@/components/blocks/MainSection'
import NewsSlider from '@/components/blocks/NewsSlider'
import Maps from '@/components/blocks/Maps'
import Reviews from '@/components/blocks/Reviews'
export default {
  components: {
    MainSection,
    ShiftSelection,
    NewsSlider,
    Reviews,
    Maps
  },
  methods: {
    ...mapActions({
      fetchNews: 'news/fetchNews'
    })
  },
  created () {
    this.fetchNews()
  }
}
</script>
